import { useEffect, useState } from 'react';

interface ToggleSliderProps {
  /**  Left button text */
  leftLabel: string;
  /**  Right button text */
  rightLabel: string;
  /** Left toggle callback */
  leftCallback?: any;
  /** Right toggle callback */
  rightCallback?: any;
  /** Whether the toggle is true or false */
  isToggled?: boolean;
}

export const ToggleSlider = ({
  leftLabel,
  rightLabel,
  leftCallback,
  rightCallback,
  isToggled = false,
}: ToggleSliderProps) => {
  const [toggled, setToggled] = useState(isToggled);
  const handleLeftToggle = () => {
    setToggled(false);
    if (leftCallback) leftCallback();
  };
  const handleRightToggle = () => {
    setToggled(true);
    if (rightCallback) rightCallback();
  };
  useEffect(() => {
    setToggled(isToggled);
  }, [isToggled]);
  return (
    <div className={`toggle-slider${toggled ? ' right' : ''}`}>
      <button className="button transparent" onClick={handleLeftToggle}>
        {leftLabel}
      </button>
      <button className="button transparent" onClick={handleRightToggle}>
        {rightLabel}
      </button>
    </div>
  );
};

export default ToggleSlider;
